import './search-form-collapsible';
import './global-select-category';


// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/search/global-search/index.js